import React, {FunctionComponent, ReactHTMLElement, DetailedHTMLProps, HTMLAttributes} from "react";

interface InputProps extends DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  className?: string;
  label?: string;
}

const Input: FunctionComponent<InputProps> = ({className, label, ...rest}) => {
  return (
    <div className={`flex flex-col${className ? ' ' + className : ''}`}>
      {
        label &&
        <label className='mb-1 pl-2 text-gray-600'>{label}</label>
      }
      <input className='bg-white bg-transparent block border border-gray-400 hover:border-gray-500 leading-tight focus:outline-none focus:shadow-outline px-2 py-2 rounded shadow w-full' {...rest} />
    </div>
  )
}

export default Input;
